import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import { getTimeArrayFromRangeKey } from '../dateTime/pickerParseRangeValues.js';
export default {
  name: 'CoreCsvExportDialogMulti',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'digitalTwin'
    }
  },
  data: function data() {
    return {
      name: null,
      accountId: null,
      filter: [],
      filterType: this.type,
      dateFrom: null,
      dateTo: null,
      searchTotalCount: null,
      dataAggregation: 'ALL',
      search: [],
      searchOperator: 'AND',
      stateIdentifiers: [],
      selectedStates: [],
      stateIdSearchInput: null,
      csvOptions: {
        headers: [],
        includeHeaders: true
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), {}, {
    formIsValid: function formIsValid() {
      return Boolean(this.name) && Boolean(this.accountId);
    },
    dataAggregationItems: function dataAggregationItems() {
      return [{
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.ALL'),
        value: 'ALL'
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.LAST'),
        value: 'LAST'
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.MAX'),
        value: 'MAX'
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.SUM'),
        value: 'SUM'
      }];
    },
    searchTotalCountMessage: function searchTotalCountMessage() {
      if (this.searchTotalCount === null || this.searchTotalCount === undefined || (this.filter || []).length === 0) {
        return null;
      }

      var typeDevice = this.filterType === 'digitalTwin' ? this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.digitalTwins') : this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.virtualDevices');

      if (this.searchTotalCount === -1) {
        return this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.totalCountError', {
          devices: typeDevice
        });
      }

      return this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.totalCount', {
        count: this.searchTotalCount,
        devices: typeDevice
      });
    }
  }),
  watch: {
    isOpen: function isOpen() {
      if (this.isOpen) {
        this.name = null;
        this.accountId = null;
        this.filter = null;
        this.initRange();
      }
    },
    accountId: function accountId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchFilterDeviceCount(this.filterType, this.filter);
      }
    }
  },
  mounted: function mounted() {
    this.fetchAccounts();
  },
  methods: {
    initRange: function initRange() {
      var range = getTimeArrayFromRangeKey('now-24h');
      this.dateFrom = range[0];
      this.dateTo = range[1];
    },
    updateTimeRange: function updateTimeRange(ev) {
      this.dateFrom = ev.from;
      this.dateTo = ev.to;
    },
    updateFilter: function updateFilter(search, operator) {
      this.filter = search;
      this.filterOperator = operator;
      this.fetchFilterDeviceCount(this.filterType, this.filter, this.filterOperator);
    },
    fetchFilterDeviceCount: function fetchFilterDeviceCount(type, filter, operator) {
      var _this = this;

      var searchItems = (filter || []).map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });
      var accountFilter = this.accountId ? [{
        type: 'tenantIds',
        ids: [this.accountId]
      }] : [];

      if (searchItems.length === 0) {
        // if there are no search items, in case the search filter was emptied, reset the total count
        // and return. do not search for all available devices.
        this.searchTotalCount = null;
        this.stateIdentifiers = [];
        this.selectedStates = [];
        return;
      }

      var apiMethod = type === 'virtualDevice' ? ApiService.virtualDeviceFetch : ApiService.digitalTwinsFetch;
      var apiParams = [this, // context
      null, // userId
      [], // scopeIds
      accountFilter, // filters
      null, // options
      {
        variable: 'id',
        direction: 'ASC'
      }, // orderBy
      0, // offset
      1, // limit
      searchItems];

      if (type === 'virtualDevice') {
        apiParams.push(undefined, true, // include identifiers
        operator);
      } else {
        apiParams.push(true // include identifiers
        );
      }

      apiMethod.apply(void 0, apiParams).then(function (result) {
        _this.searchTotalCount = result.totalCount;
        _this.stateIdentifiers = result.identifiers.sort(function (a, b) {
          return a.key.localeCompare(b.key, undefined, {
            numeric: true
          });
        });
        _this.selectedStates = [];
      }).catch(function () {
        _this.searchTotalCount = -1;
        _this.stateIdentifiers = [];
        _this.selectedStates = [];
      });
    },
    handleSave: function handleSave() {
      var _this2 = this;

      var searchItems = (this.filter || []).map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });
      var data = {
        title: this.name,
        type: this.filterType,
        tenantId: this.accountId,
        search_items: JSON.parse(JSON.stringify(searchItems)),
        fromTime: new Date(this.dateFrom * 1000).toISOString(),
        toTime: new Date(this.dateTo * 1000).toISOString(),
        search_operator: this.searchOperator,
        stateIdentifiers: this.selectedStates,
        aggregateFunction: this.dataAggregation,
        csvOptions: this.csvOptions.includeHeaders ? {
          headers: this.csvOptions.headers.map(function (c) {
            return {
              name: c.name,
              mappedValue: c.mappedValue
            };
          }),
          includeHeaders: true
        } : {
          includeHeaders: false
        }
      };
      ApiService.createBackgroundRunnerBulkExportDeviceStates(data).then(function () {
        _this2.$snack(_this2.$i18n_t('BackgroundJobs.ScheduledExports.snacks.runSuccess'), 'success');
      }).catch(function (error) {
        console.error(error);

        _this2.$snack(_this2.$i18n_t('BackgroundJobs.ScheduledExports.snacks.runError'), 'error');
      }).finally(function () {
        _this2.close();
      });
    },
    resetDialog: function resetDialog() {
      this.searchTotalCount = null;
      this.name = null;
      this.accountId = null;
      this.filter = [];
      this.filterType = this.type;
      this.dateFrom = null;
      this.dateTo = null;
      this.dataAggregation = 'ALL';
      this.searchOperator = 'AND';
      this.searchItems = [];
      this.search = [];
      this.stateIdentifiers = [];
      this.selectedStates = [];
      this.csvOptions = {
        headers: [],
        includeHeaders: true
      };
    },
    close: function close() {
      this.resetDialog();
      this.$emit('close');
    },
    fetchAccounts: function fetchAccounts() {
      var _this3 = this;

      this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        _this3.accounts = accounts;
      }).catch(function (error) {
        _this3.$snack(_this3.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');

        console.error(error);
      });
    }
  }
};